export const SEGMENT_PROCESS_APPLIES_TO = {
  CV: 'CV',
  EMPLOYEE: 'Individual',
  PROJECT: 'Project',
};

export const COMPETENCY_ASSIGNMENT_STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
};

export const COMPETENCY_VISIBILITY_STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
};

export const SEGMENT_VISIBILITY_STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
};

export const SEGMENT_PROCESS_APPLIES_TO_OPTIONS = [
  { value: SEGMENT_PROCESS_APPLIES_TO.CV, label: 'CV' },
  { value: SEGMENT_PROCESS_APPLIES_TO.EMPLOYEE, label: 'Individual' },
  { value: SEGMENT_PROCESS_APPLIES_TO.PROJECT, label: 'Project' },
];

export const COMPETENCY_ASSIGNMENT_OPTIONS = [
  { value: COMPETENCY_ASSIGNMENT_STATUS.ENABLED, label: 'Enabled' },
  { value: COMPETENCY_ASSIGNMENT_STATUS.DISABLED, label: 'Disabled' },
];

export const COMPETENCY_VISIBILITY_OPTIONS = [
  { value: COMPETENCY_VISIBILITY_STATUS.ENABLED, label: 'Enabled' },
  { value: COMPETENCY_VISIBILITY_STATUS.DISABLED, label: 'Disabled' },
];

export const SEGMENT_VISIBILITY_OPTIONS = [
  { value: SEGMENT_VISIBILITY_STATUS.ENABLED, label: 'Enabled' },
  { value: SEGMENT_VISIBILITY_STATUS.DISABLED, label: 'Disabled' },
];
